import {
	ItemViewModel, StringPropertyViewModel, GuidPropertyViewModel, EnumPropertyViewModel, BoolPropertyViewModel, NumericPropertyViewModel, DateTimeOffsetPropertyViewModel, DateTimePropertyViewModel,
	NNumericPropertyViewModel, NDateTimeOffsetPropertyViewModel, NDateTimePropertyViewModel, NEnumPropertyViewModel, NTimeSpanPropertyViewModel, BaseRowNumberCollectionViewModel, BaseRowNumberItemViewModel
} from '@nts/std';
import { SignerLayout } from '../../domain-models/signer-layout';
import { SignerLayoutIdentity } from '../../domain-models/signer-layout.identity';

export class GeneratedSignerLayoutCollectionItemViewModel extends BaseRowNumberItemViewModel<SignerLayout, SignerLayoutIdentity> {

	private _signerSerial: NumericPropertyViewModel;

	public get signerSerial(): NumericPropertyViewModel {
		return this.getNumericPropertyViewModel((value) => { this._signerSerial = value; }, this._signerSerial, 'signerSerial');
	}

	private _signerLayoutSerial: NumericPropertyViewModel;

	public get signerLayoutSerial(): NumericPropertyViewModel {
		return this.getNumericPropertyViewModel((value) => { this._signerLayoutSerial = value; }, this._signerLayoutSerial, 'signerLayoutSerial');
	}

	private _specificPage: NNumericPropertyViewModel;

	public get specificPage(): NNumericPropertyViewModel {
		return this.getNNumericPropertyViewModel((value) => { this._specificPage = value; }, this._specificPage, 'specificPage');
	}

	private _lastPage: BoolPropertyViewModel;

	public get lastPage(): BoolPropertyViewModel {
		return this.getBoolPropertyViewModel((value) => { this._lastPage = value; }, this._lastPage, 'lastPage');
	}

	private _leftCoordinate: NNumericPropertyViewModel;

	public get leftCoordinate(): NNumericPropertyViewModel {
		return this.getNNumericPropertyViewModel((value) => { this._leftCoordinate = value; }, this._leftCoordinate, 'leftCoordinate');
	}

	private _topCoordinate: NNumericPropertyViewModel;

	public get topCoordinate(): NNumericPropertyViewModel {
		return this.getNNumericPropertyViewModel((value) => { this._topCoordinate = value; }, this._topCoordinate, 'topCoordinate');
	}

}
